<div class="input-container {{ variant }}" [class.compact]="size === 'compact'" [class.focused]="isFocused">
  @if (leftIconTemplate) {
    <ng-container *ngTemplateOutlet="leftIconTemplate"></ng-container>
  } @else {
    <i class="ph ph-magnifying-glass"></i>
  }
  <input
    #inputFilterText
    type="text"
    placeholder="{{ placeholder }}"
    [(ngModel)]="text"
    (focus)="onInputFocus()"
    (blur)="onInputBlur()"
    (keydown.enter)="emitText(); inputFilterText.blur()"
    (keydown.tab)="emitText(); inputFilterText.blur()"
    (keyup)="textChanged()"
  />
  <i class="ph ph-x" *ngIf="text" (click)="clearInput()"></i>
</div>
